import { CSSProperties } from "react"

export class StyleHelper {

  /**
   * Calculates a color in HSL-format from a string, e.g. a username
   *
   * @param text the text to calculate the color from, e.g. a username
   * @param saturation of the color
   * @param lightness of the color
   * @returns a color in HSL-format to be used for arbitrary but permanent color of a users avatar
   * @see Sergio Pedercini: https://medium.com/@pppped/compute-an-arbitrary-color-for-user-avatar-starting-from-his-username-with-javascript-cd0675943b66
   */
  static stringToHslColor = (text: string, saturation: number, lightness: number): string => {
    let hash = 0
    for (let i = 0; i < text.length; i++) {
      // eslint-disable-next-line no-bitwise
      hash = text.charCodeAt(i) + ((hash << 5) - hash)
    }

    const h = hash % 360
    return 'hsl(' + h.toString() + ', ' + saturation.toString() + '%, ' + lightness.toString() + '%)'
  }

  /**
   * produces a background-color style with opacity depending on the given values
   * may be used to calculate stable and repeatable color shapes of elements
   *
   * @param elementIndex index of an element within a list of elements
   * @param maxElements number of all elements
   * @param bottomLimit bottom opacity-limit between 0 - 1
   * @param upperLimit upper opacity-limit between 0 - 1
   * @returns CSSProperties that set the background-color opacity to a calculated value
   */
  static backgroundColorOpacity = (elementIndex: number, maxElements: number, bottomLimit = 0.7, upperLimit = 0.9): CSSProperties => {
    const opacityIndex = elementIndex / maxElements
    const limitedOpacity = bottomLimit + (upperLimit - bottomLimit) * opacityIndex

    return {
      backgroundColor: "rgba(255, 255, 255," + limitedOpacity.toString() + ")"
    }
  }
}